(function () {
    "use strict";
    angular
        .module("skillBuilderSaaS")
        .controller("CropPictureModalCtrl", ["$scope", "$timeout", "$translate", "cropPictureService", "ngJcropConfig", "messageService", "Upload", "FILE_FORMATS", "cropData", "jcropConfig", "options", cropPictureModalCtrl]);
    function cropPictureModalCtrl($scope, $timeout, $translate, cropPictureService, ngJcropConfig, messageService, Upload, FILE_FORMATS, cropData, jcropConfig, options) {
        var vm = this;
        vm.jcropData = {};
        vm.model = {};
        vm.saving = false;
        vm.loading = true;
        vm.hasPicture = false;
        vm.tempFolderGuid = "";
        vm.acceptedFileTypes = !options.supportedFiles ? FILE_FORMATS.image : options.supportedFiles;
        vm.fileSize = !options.fileSize ? "10MB" : options.fileSize;
        vm.acceptedFileTypesFormated = vm.acceptedFileTypes.replace(/,/g, ", "); //Adds a space after each comma for better displaying
        //Configure JCrop Properties
        ngJcropConfig.profile = {};
        angular.merge(ngJcropConfig.profile, ngJcropConfig.default, jcropConfig);
        ngJcropConfig.profile.jcrop.onChange = updateCrop;
        ngJcropConfig.profile.jcrop.onSelect = updateCrop;
        ngJcropConfig.profile.previewImgStyle = {
            display: "none"
        };
        vm.jcropData.coords = [0, 0, 0, 0, 0, 0];
        vm.hasPicture = cropData !== null;
        if (vm.hasPicture) {
            vm.model = cropData;
            loadCropArea(cropData);
        }
        vm.loading = vm.hasPicture;
        vm.upload = function (file) {
            vm.file = file;
            if (file) {
                var url = "api/cropPicture/uploadPicture";
                if (vm.tempFolderGuid)
                    url += "/" + vm.tempFolderGuid;
                file.upload = Upload.upload({
                    url: url,
                    data: { file: file }
                });
                file.upload.then(function (response) {
                    $timeout(function () {
                        vm.tempFolderGuid = response.data.tempFolderGuid;
                        if (vm.model === null)
                            vm.model = {};
                        vm.model.fileUrl = response.data.fileUrl;
                        vm.model.tempFolderGuid = response.data.tempFolderGuid;
                        vm.model.coordinates = null;
                        vm.model.removePicture = false;
                        loadCropArea(response.data);
                        vm.file.progress = 0;
                    });
                }, function (error) {
                    if (error.status > 0) {
                        messageService.error(error);
                    }
                    vm.file.progress = 0;
                }, function (evt) {
                    file.progress = Math.min(100, Math.round(100.0 * evt.loaded / evt.total));
                });
            }
        };
        vm.save = function () {
            if (vm.model === null) {
                if (vm.tempFolderGuid !== "")
                    cropPictureService.removeTempFolder(vm.tempFolderGuid);
                $scope.$dismiss();
            }
            else {
                if (vm.coords.h === 0 && vm.coords.w === 0)
                    messageService.error("common.error.invalidCropSize");
                else {
                    vm.model.coordinates = vm.coords;
                    $scope.$close({ cropData: vm.model });
                }
            }
        };
        vm.removePicture = function () {
            vm.hasPicture = false;
            vm.model = cropData;
            if (cropData !== null)
                vm.model.removePicture = true;
        };
        function updateCrop(coords) {
            vm.coords = coords;
            $scope.$apply();
        }
        function loadCropArea(result) {
            var originalPicture = result.fileUrl;
            // Loading image to get the actual Width and Height
            var image = new Image();
            image.onload = function () {
                $scope.$apply(function () {
                    ngJcropConfig.profile.jcrop.trueSize = [image.naturalWidth, image.naturalHeight];
                    vm.jcropData.src = originalPicture;
                    var coordinates = result.coordinates;
                    if (!coordinates) {
                        vm.jcropData.coords = [0, 0, image.naturalWidth, image.naturalHeight, image.naturalWidth, image.naturalHeight];
                    }
                    else {
                        vm.jcropData.coords = [coordinates.x, coordinates.y, coordinates.x2, coordinates.y2, coordinates.w, coordinates.h];
                    }
                    vm.loading = false;
                    vm.hasPicture = true;
                    $timeout.cancel(cantLoadImageTimeout);
                });
            };
            image.onerror = function () {
                vm.loading = false;
            };
            image.src = originalPicture;
            var cantLoadImageTimeout = $timeout(function () {
                vm.loading = false;
                vm.hasPicture = false;
                vm.loading = false;
            }, 10000);
        }
    }
}());
